import { mapGetters, mapActions } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      hotspots: 'level4/hotspots',
    }),
  },
  methods: {
    ...mapActions({
      updateHotspots: 'level4/updateHotspots',
    }),
    setSpotState(bildposNummer, state = 'hover') {
      const hotspots = this.hotspots.map((hotspot) => ({
        ...hotspot,
        [state]: hotspot.bildposNummer === parseInt(bildposNummer, 10),
      }));
      this.updateHotspots(hotspots);
    },
  },
};
